//this hook checks the roles in state to see if the current user is admin
import { useSelector } from "react-redux";

const useIsAdmin = () => {
  const roles = useSelector(
    (state) => state.workshops.user.idTokenClaims?.roles
  );

  if (roles?.some((role) => role === "Workshops.Admin")) return true;
  return false;
};

export default useIsAdmin;
